export default {
  refund: "student/refund",
  getRefund: (id) => `student/refund/show?no=${id}`,
  patchRefund: "student/refund/update",
  deleteRefund: "student/refund/delete",
  deleteAttachment: "student/refund/deleteAttachment",
  getStudentPaymentBalance: "student/refund/getStudentPaymentBalance",
  sendStudentRequestForApproval: "student/refund/sendStudentRequestForApproval",
  cancelStudentApprovalRequest: "student/refund/cancelStudentApprovalRequest",
};
